module.exports = __webpack_public_path__ + "img/1.a4811921.png";